var BigNumber = require('bignumber.js')

const GlobalHelpers = {
  install (Vue) {
    Vue.prototype.$globalConverter = function (value) {
      if (typeof value === 'undefined' || value === '' || typeof value === 'object') {
        return 0
      } else {
        var number = new BigNumber(value.toString(10), 10)
        var division = number.dividedBy(new BigNumber('1000000000000000000', 10))
        return (division.toString(10))
      }
    }
    Vue.prototype.$checkStatusResponse = function (status) {
      if (status === 200) {
        return true
      } else if (status === 404) {
        return false
      } else {
        return 'Exception not handled'
      }
    }
  }
}

export default GlobalHelpers
